module.exports = __webpack_public_path__ + "img/2025-03-12b_4.e08a24cc.jpg";